export default class DeleteVoicemailRecording {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, conversationItemId }) {
    this.context.gateways.voiceRecording.deleteVoicemailRecording(customerId, conversationItemId);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/conversation_item/voice_recording/delete_voicemail_recording.js